import { render } from "./DsDialog.vue?vue&type=template&id=a00118e6&scoped=true"
import script from "./DsDialog.vue?vue&type=script&lang=js"
export * from "./DsDialog.vue?vue&type=script&lang=js"

import "./DsDialog.vue?vue&type=style&index=0&id=a00118e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00118e6"]])

export default __exports__